import { createTheme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// export const win_color = "#1C2633";
export const win_color = "#0D1B2A";
export const loss_color = "#3A0D0D";
// export const loss_color = "#0D3A0D";

export const SIDE_COLORS = {
  Red: "#8B0000",  // Dark Red
  Blue: "#1E3A5F", // Deep Navy Blue
} as any;

export const scrollable = {
    overflow:'auto',
    "&::-webkit-scrollbar": {
        width: "2px",
        height:"2px",
        boxShadow: `
      0px 10px 30px rgba(0, 0, 0, 0.6), 
      0px 4px 15px rgba(0, 0, 0, 0.4), 
      inset 0px 0px 10px rgba(0, 0, 0, 0.3)
    `,
    },
    "&::-webkit-scrollbar-track": {
        background: "#e1e1e1e",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: '#ffffff',

    },
    "&::-webkit-scrollbar-thumb:hover": {
        background: "#ffffff",
    },
};

export const defender_color = "#257D67";
export const attacker_color = "#692A40";

const getDesignTokens = (mode: PaletteMode) => ({
    // components: {
    //     MuiPaper: {
    //         styleOverrides: {
    //             root: {
    //                 // background: 'rgba(20, 20, 30, 1)', // Remove unwanted MUI styles
    //                 backgroundColor: 'rgba(20, 20, 30, 0.95)', // Apply custom background
    //             },
    //         },
    //     },
    // },
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: {
            main: '#90caf9',
          },
          secondary: {
            main: '#dc004e',
          },
          background: {
            default: '#ffffff',
            paper: '#f4f6f8',
          },
          text: {
            primary: '#000000',
            secondary: '#555555',
          },
        }
      : {
          // palette values for dark mode
          primary: {
            main: '#ffffff',
          },
          secondary: {
            main: '#f48fb1',
          },
          background: {
              // default: 'black',
              // paper: 'black'
            default: 'rgba(0, 0, 5, 0.95)',
            paper: "rgba(0, 0, 5, 0.95)",
          },
          text: {
            primary: '#ffffff',
            secondary: '#bbbbbb',
          },
        }),
  },
  typography: {
    fontFamily: "'Poppins', sans-serif", // Replace with your desired font
  },
    components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "rgba(0, 0, 5, 0.95)",
        },
        arrow: {
          color: "rgba(0, 0, 5, 0.95)",
        },
      },
    },
  },
});

export const createAppTheme = (mode: PaletteMode) => createTheme(getDesignTokens(mode));

export const getNeonColor = (theme: any) => theme.palette.primary.main;
